var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.onlyshow)?_c('el-cascader',{attrs:{"props":{ expandTrigger: 'hover' },"options":_vm.props},on:{"change":_vm.change},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}):_c('div',[_vm._v(" "+_vm._s(_vm.showStr)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }